import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import imgDashboard from '../../../assets/img/hero/about/dashboard.png'
import imgPOS from '../../../assets/img/hero/about/pos.png'

export default function About() {

    const aboutSectionRef = useRef<HTMLDivElement>(null)
    const currentLocation = useLocation()

    useEffect(()=>{
        if(currentLocation.hash === "#about"){
            aboutSectionRef?.current?.scrollIntoView()
        }
    },[currentLocation.hash])

    return (
        <section 
            className='p-24 md:px-0 flex flex-col items-center' 
            ref={aboutSectionRef}
        >

            <div className='w-2/5 md:w-4/5 mb-7 xs:mb-10'>
                <h5 className="text-3xl font-bold text-primary text-center">
                    It's easy to manage your retail with The Shopkeeper <div className="w-2 h-2 rounded-full inline-block bg-secondary"/>
                </h5>
                {/* <p></p> */}
            </div>

            {/* <p className='text-graphite my-5'>
                The Shopkeeper comes with sophisticated yet easy to use tools and features that enables you to 
                keep track of your sales, inventory and employees.
            </p> */}

            <div className="w-11/12 mt-8 flex xs:flex-col justify-between items-center mb-32">


                <div className='w-5/12 xs:w-full xs:mb-7'>
                    <h5 className="text-primary text-2xl font-semibold">Dashboard briefing</h5>
                    <div className="inline-flex my-7 xs:my-3">
                        <div className="inline-block bg-secondary w-36 h-1"/>
                        <div className="inline-block bg-secondary w-2 ml-3 h-1"/>
                    </div>
                    <div className='mw-4/5'>
                        <p className="text-graphite">
                            Get a detailed brief on your expenses, sales, inventory, profits, employees and etc on the dashboard. 
                            It's available to you on the first page.
                        </p>
                    </div>
                </div>

                <div className="w-1/2 xs:w-full h-72 bg-primary">
                    <img src={imgDashboard} alt="Dashboard briefing" className="w-full h-full" />
                </div>


            </div>

            <div className="w-11/12 mt-8 flex xs:flex-col flex-row-reverse justify-between items-center">


                <div className='w-5/12 xs:w-full xs:mb-7'>
                    <h5 className="text-primary text-2xl font-semibold">Simple point of sale screen</h5>
                    <div className="inline-flex my-7 xs:my-3">
                        <div className="inline-block bg-secondary w-36 h-1"/>
                        <div className="inline-block bg-secondary w-2 ml-3 h-1"/>
                    </div>
                    <div className='mw-4/5'>
                        <p className="text-graphite">
                            The Shopkeeper has a very simplified point of sale screen.
                            All your employees need to know is how to read and write english. 
                            They will adapt to it as if they have used The Shopkeeper before.
                        </p>
                    </div>
                </div>

                <div className="w-1/2 xs:w-full h-72 bg-primary">
                    <img src={imgPOS} alt="Dashboard briefing" className="w-full h-full" />
                </div>


            </div>
            
        </section>
    )
}
